export const events = {
  imports: {
    started: 'Universal Importer: Start Process',
    processRequested: 'Universal Importer: Process Requested',
    processRequestError: 'Universal Importer: Process Request Error',
    mappingStep: 'Universal Importer: Mapping Requested',
    cancelled: 'Universal Importer: Process Cancelled',
    headerStep: 'Universal Importer: Move to Header Step',
    reviewStep: 'Universal Importer: Move to Review Step',
    attachFile: 'Universal Importer: Upload File',
    downloadTemplate: 'Universal Importer: Download Template',
    fixErrors: 'Universal Importer: Fix Error Rows',
    startedFixErrors: 'Universal Importer: Start Process - Fixed Error Rows',
  },
}
